const knowledgeBaseMge = r => require.ensure([], () => r(require('@/page/knowledgeBase/knowledgeBaseMge')), 'knowledgeBaseMge');
const knowledgeBaseDetail = r => require.ensure([], () => r(require('@/page/knowledgeBase/knowledgeBaseDetail/knowledgeBaseDetail')), 'knowledgeBaseDetail');
const knowledgeBaseMore = r => require.ensure([], () => r(require('@/page/knowledgeBase/knowledgeBaseMore/knowledgeBaseMore')), 'knowledgeBaseMore');
const knowledgeBaseAdd = r => require.ensure([], () => r(require('@/page/knowledgeBase/knowledgeBaseAdd/knowledgeBaseAdd')), 'knowledgeBaseAdd');

const knowledgeBaseRouter = {
  path: '',
  component: knowledgeBaseMge,
  meta: {
    icon: '',
    right: [],
    isShowMenu: false,
    keepAlive:true,
  },
  name: '',
  redirect: '/knowledgeBaseMge',
  children: [{
      path: '/knowledgeBaseMore',
      component: knowledgeBaseMore,
      name: '更多知识库',
      meta: {
        right: [],
        isShowMenu: false,
        keepAlive:true,
      },
    },
    {
      path: '/knowledgeBaseDetail',
      component: knowledgeBaseDetail,
      name: '知识详细',
      meta: {
        right: [],
        isShowMenu: false,
        keepAlive:true,
      },
    }, {
      path: '/knowledgeBaseAdd',
      component: knowledgeBaseAdd,
      name: '发布知识',
      meta: {
        right: [],
        isShowMenu: false,
        keepAlive:true,
      },
    },
  ]
};

export default knowledgeBaseRouter;